import { render } from "./addVideoIcon.vue?vue&type=template&id=4d9c78b9"
import script from "./addVideoIcon.vue?vue&type=script&lang=js"
export * from "./addVideoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__